






















































































































































import Vue from 'vue'
import drawer from './drawer.vue'
import modal from './AttributeEditOrAdd.vue'
import AttributeHistoryModal from './AttributeHistoryModal.vue';

import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'
import { columnsQuality, columnsRealtime, isTakeEffected } from './data'
import { getUserInfo, getToken } from '@/utils/auth'
import {
  IotAppPropertyServiceProxy,
  IotAppModelTemplateServiceProxy, GatewayServiceProxy,
  GetIotAppPropertyPageListDTO
} from '@/service-proxies/app-v2/iot-console.service-proxies'

const apsp = new IotAppPropertyServiceProxy()
const iamtsp = new IotAppModelTemplateServiceProxy()

const gatewayServ = new GatewayServiceProxy()

const deleteProperty = apsp.deleteIotAppProperty.bind(apsp)
const exportFn = apsp.exportProperties.bind(apsp)
const importFn = apsp.importProperties.bind(apsp)
const submitProperty = apsp.submitProperty.bind(apsp)
export default Vue.extend({
  props: ['app', 'gatewayCode', 'gatewayId'],
  components: { drawer, modal, AttributeHistoryModal },
  data() {
    return {
      gateway:{},
      originalData: [],
      appProps: [],
      liveData: [],
      visible: false,
      loading: false,
      selectedRowKeys: [],
      editData: {},
      editingKey: '',
      type: 'add',
      deleteLoading: false,
      ws: null,
      modelList: [],
      modelListMap: [],
      modelVisible: false,
      saveType: 0,
      templateName: '',
      oldTemplateId: undefined,
      modelTemplateId: '',
      dropdownVisible: false,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        filter: ''
      },
    }
  },
  computed: {
    drawerTitle() {
      if (this.app) {
        return this.app.name + this.$t('page_workstation_maintain_prop')
      } else {
        return ''
      }
    },
    isTakeEffected() {
      return isTakeEffected.map((item) => {
        return this.$t(item)
      })
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange
      }
    },
    columnsQuality() {
      return columnsQuality.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    columnsRealtime() {
      return columnsRealtime.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  beforeDestroy() {
    this.disConnectWs()
  },
  watch:{
    app:{
      handler(newValue,oldValue){
        if(newValue){
          this.pagination= {
            current: 1,
            pageSize: 20,
            total: 0,
            filter: ''
          };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /*导出*/
    async exportFn() {
      let iotAppId = this.app.id
      return await exportFn(iotAppId)
    },
    /*下载模板*/
    async downloadFn() {
      return
    },
    /*导入*/
    async importFn(file) {
      let iotAppId = this.app.id
      const formData = new FormData()
      formData.append('file', file, file.name)
      formData.append('iotAppId', iotAppId)
      return await importFn(formData)
    },
    showDrawer() {
      this.visible = true
      this.getList()
      this.getModelTemplateList()

      gatewayServ.getGatewayById(this.gatewayId)
            .then(res=>this.gateway=res);
    },
    onClose() {
      this.visible = false
      this.disConnectWs()
    },
    // 表格勾选
    onSelectChange(selectedRowKeys: [], selectedRows: []) {
      this.selectedRowKeys = selectedRowKeys
    },
    // 属性列表
    async getList() {
      this.disConnectWs()
      this.appProps = []
      this.originalData = []
      this.liveData = []
      if (!this.app || !this.gatewayCode) {
        return
      }
      this.loading = true
      try {
        const dto = new GetIotAppPropertyPageListDTO();
        dto.current=this.pagination.current;
        dto.size= this.pagination.pageSize;
        dto.appCode= this.app.code;
        dto.gatewayCode = this.gatewayCode;
        


        let { items, totalCount} = await apsp.getIotAppPropertyPageList(dto)
        this.pagination.total= totalCount;
        // let { items } = await apsp.getIotAppPropertyList(this.app.code, this.gatewayCode)
        this.appProps = cloneDeep(items)
        this.originalData = cloneDeep(items)
        this.openLiveDataModel(items)
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    // 新建、编辑
    openEditModal(record?: any) {
      this.editData = record ? record : {}
      this.type = 'add'
      if (record && record.id) {
        this.type = 'edit'
      }
      this.$refs.modal.trigger()
    },
    // 历史数据
    openHistoryModal(record?: any){
      this.$refs.historyModal.open(record.gatewayCode, record.iotAppCode,record.name);
    },
    // 删除属性
    async handleDelete(id?) {
      this.deleteLoading = true
      let params = {
        propertyIdList: []
      }
      params.propertyIdList = id ? [id] : this.selectedRowKeys
      try {
        await deleteProperty(params)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.getList()
      } catch (e) {
        console.log(e)
      }
      this.deleteLoading = false
    },
    // 执行变更
    async change() {
      try {
        await submitProperty(this.app.code, this.gatewayCode)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.getList()
      } catch (e) {
        console.log(e)
      }
    },
    changeValue(val, record, index) {
      this.appProps[index].currentValue = val
      this.appProps = cloneDeep(this.appProps)
    },
    handleTableChange(current: number, pageSize: number) {
      const pager = {
        pageSize: pageSize,
        current: current
      }
      Object.assign(this.pagination, pager)
      this.getList();
    },
    // 写入当前值
    async saveCurrentValue(record, index) {
      try {
        let params: any = {
          appCode: this.app.code,
          gatewayCode: this.gatewayCode,
          propertyValueList: []
        }
        let IotPropertyValue = {
          dataValue: record.currentValue,
          datatype: Number(record.type),
          propertyCode: record.code
        }
        params.propertyValueList.push(IotPropertyValue)
        let res = await apsp.writePropertyValue(params)
        if (res.code === 0) {
          this.$message.success(this.$t('page_resource_pool_success'))
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (e) {
        this.appProps[index] = this.originalData[index]
        this.appProps = cloneDeep(this.appProps)
      }
    },
    // 读取属性值
    async readPropertyValue(record, index) {
      try {
        let params: any = {
          appCode: this.app.code,
          gatewayCode: this.gatewayCode,
          propertyCodeList: [record.code]
        }
        let { items } = await apsp.readPropertyValue(params)

        if (items.length) {
          let value = items[0].propertyValue
          this.appProps[index].currentValue = value
          this.appProps = cloneDeep(this.appProps)
        }

      } catch (e) {
        console.log(e)
      }
    },
    refresh() {
      this.getList()
    },
    initLiveData(records = this.appProps || []) {
      this.liveData = records.map((item) => ({
        propertyName: item.name,
        propertyValue: '-',
        reportTime: '-'
      }))
    },
    // 查看实时数据
    async openLiveDataModel(items) {
      this.initLiveData()
      const topicList = items.map(c=>`${getUserInfo().tenant_id}/${this.gatewayId}/${this.app.id}/${c.name}`);
      
      /*
      let destination = `${getUserInfo().tenant_id}/${this.gatewayId}/${
        this.app.id
        }/#`
        */

      const global: any = window

      this.ws = new WebSocket(
        `${global.REALTIME_WEBSOCKET_URL}/${getToken()}`
      )
      const onConnect = () => {
        const data = JSON.stringify({
          command: 'SUBSCRIBE',
          data: [/*destination*/ ...topicList],
          context: String(Date.now())
        })
        this.ws.send(data)
      }

      const onError = (err) => {
      }

      // 接收实时数据并处理
      const onReceive = (message) => {
        var data, command
        const body = message && message.data
        if (!body) return
        try {
          const _body = JSON.parse(body)
          data = _body.data
          command = _body.command
          if (command === 'AUTHENTICATION' && data.status !== 'success') {
            this.$message.error(this.$t('page_workstation_maintain_token_overdue'))
            return
          }
          if (command === 'CONNECTION' && data.status === 'failed') {
            this.$message.error(this.$t('page_workstation_maintain_connect_failed'))
            return
          }
        } catch (err) {
          data = null
          command = null
        }
        if (!data || command !== 'DATA') return
        const index = this.liveData.findIndex(
          (v) => (v.propertyName.toLowerCase() === data.propertyName.toLowerCase())
        )
        if (~index) {
          if (data.propertyValue.includes('timestamp')) {
            try {
              const v = JSON.parse(data.propertyValue)
              const t = dayjs(Number(v.timestamp)).format('YYYY-MM-DD HH:mm:ss')
              if (t !== 'Invalid Date') {
                v.timestamp = t
              } else {
                delete v.timestamp
              }
              data.propertyValue = JSON.stringify(v)
            } catch (error) {
            }
          }
          this.$set(this.liveData, index, data)
        }
      }
      this.ws.addEventListener('error', onError)
      this.ws.addEventListener('message', onReceive)
      this.ws.addEventListener('open', onConnect)
    },
    disConnectWs() {
      if (this.ws) {
        this.ws.close()
        this.ws = null
      }
      this.initLiveData()
    },
    handleMenuClick(e) {
      this.modelTemplateId = e.key
      this.dropdownVisible = false
      this.config()
    },
    // 获取模板列表
    async getModelTemplateList() {
      this.modelList = []
      this.modelListMap = []
      let { items } = await iamtsp.getModelTemplateList()
      if (items.length) {
        this.modelList = items
        this.modelListMap = items.map(item => ({ label: item.name, value: item.id }))
      }
    },
    async deleteModel(e, data) {
      e.stopPropagation()
      this.dropdownVisible = false
      this.$confirm({
        title: this.$t('page_getwat_list_delete_the') + data.name + '?',
        content: ``,
        okText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            let params: any = {
              templateIdList: [data.id]
            }
            await iamtsp.deleteTemplate(params)
            resolve(true)
            this.getModelTemplateList()
            this.$message.success(this.$t('page_resource_pool_success'))
          })
        }
      })
    },
    trigger() {
      this.modelVisible = !this.modelVisible
      this.oldTemplateId = undefined
      this.templateName = ''
      this.saveType = 0
    },
    changeModel(value) {
      this.templateName = this.modelListMap.find(item => item.value === value).label
    },
    // 另存为模板(新增模板)
    async generateModelTemplate() {
      let params: any = {
        appCode: this.app.code,
        gatewayCode: this.gatewayCode,
        oldTemplateId: this.oldTemplateId,
        templateName: this.templateName
      }
      await iamtsp.generateModelTemplate(params)
      this.$message.success(this.$t('page_resource_pool_success'))
      this.trigger()
      this.getModelTemplateList()
    },
    // 配置选中的模板
    async config() {
      let params: any = {
        appCode: this.app.code,
        gatewayCode: this.gatewayCode,
        /** 使用的模板主键id */
        modelTemplateId: this.modelTemplateId
      }
      await iamtsp.deployModelTemplate(params)
      this.refresh()
    }

  }
})
